"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.redirectPageToLoginUrl = exports.redirectPageToUrl = void 0;
function redirectPageToUrl(url) {
    try {
        var urlObject = new URL(url, window.location.href);
        window.location.href = urlObject.href;
    }
    catch (error) {
        console.error(error);
    }
}
exports.redirectPageToUrl = redirectPageToUrl;
function redirectPageToLoginUrl(loginUrl) {
    if (!loginUrl) {
        return;
    }
    if (typeof loginUrl === 'string') {
        redirectPageToUrl(loginUrl);
    }
    else if (typeof loginUrl === 'function') {
        Promise.resolve(loginUrl())
            .then(function (loginUrl) {
            redirectPageToUrl(loginUrl);
        });
    }
}
exports.redirectPageToLoginUrl = redirectPageToLoginUrl;
